import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index_v2.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import toast from 'react-hot-toast';

Sentry.init({
    dsn: "https://703ec27fd26d1e9d2c30eb70a3dd9f84@o4509614327463936.ingest.de.sentry.io/4509614569160784",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service Worker registration: Only active in production builds. Unregistered in dev to prevent text/html MIME errors.
if (process.env.NODE_ENV === 'production') {
  // Reload once the new service worker takes control, so the update actually
  // takes effect instead of silently waiting for every tab to be closed.
  let isRefreshing = false;
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (isRefreshing) return;
    isRefreshing = true;
    window.location.reload();
  });

  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      const waitingWorker = registration.waiting;
      if (!waitingWorker) return;

      toast(
        (t) => (
          <span className="flex items-center gap-3">
            A new version is available.
            <button
              onClick={() => {
                waitingWorker.postMessage({ type: 'SKIP_WAITING' });
                toast.dismiss(t.id);
              }}
              className="font-semibold underline"
            >
              Refresh
            </button>
          </span>
        ),
        { duration: Infinity }
      );
    },
  });
} else {
  serviceWorkerRegistration.unregister();
}
